import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsFilter from "./en-us/filter.json";
import localizationEnUsTable from "./en-us/table.json";

export const localizationEnUsCases = {
  ...localizationEnUsHeader,
  ...localizationEnUsFilter,
  ...localizationEnUsTable,
};
